import { createApp } from 'vue';
import App from './App.vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import router from './router';
import { Quasar } from 'quasar'
import quasarUserOptions from './quasar-user-options.js'
import 'quasar/dist/quasar.css'

createApp(App).use(ElementPlus,Quasar, quasarUserOptions).use(router).mount('#app');